export enum ExpenseStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  PAID = 'paid',
  REJECTED = 'rejected',
}

export enum ExpenseCategory {
  SUPPLIES = 'supplies',
  TRANSPORTATION = 'transportation',
  EQUIPMENT = 'equipment',
  OFFICE = 'office',
  INSURANCE = 'insurance',
  MAINTENANCE = 'maintenance',
  UTILITIES = 'utilities',
  OTHER = 'other',
}

export interface TExpense {
  id: string;
  expenseRef: string;
  date: string;
  vendorId?: string;
  vendor?: {
    id: string;
    name: string;
    vendorRef: string;
  };
  category: ExpenseCategory;
  description: string;
  amount: number;
  status: ExpenseStatus;
  projectId?: string;
  project?: {
    id: string;
    name: string;
    projectRef: string;
  };
  submittedById?: string;
  submittedBy?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  approvedById?: string;
  approvedBy?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  approvedAt?: string;
  paidAt?: string;
  receiptUrl?: string;
  notes?: string;
  tags?: string[];
  metadata?: any;
  createdAt: string;
  updatedAt: string;
}

export interface ExpenseStats {
  totalAmount: number;
  pendingAmount: number;
  approvedAmount: number;
  paidAmount: number;
  totalCount: number;
}

export interface CreateExpenseDto {
  date: string;
  vendorId?: string;
  category: ExpenseCategory;
  description: string;
  amount: number;
  status?: ExpenseStatus;
  projectId?: string;
  notes?: string;
  receiptUrl?: string;
  tags?: string[];
  metadata?: any;
}

export interface UpdateExpenseDto extends Partial<CreateExpenseDto> {}

export interface GetExpensesParams {
  page?: number;
  pageSize?: number;
  search?: string;
  status?: ExpenseStatus;
  category?: ExpenseCategory;
  vendorId?: string;
  projectId?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
} 